import React from 'react';
import DeliveryResults from './pages/DeliveryResults';
import Marketing from './pages/Marketing';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './hooks/useTheme';
import { AuthProvider } from './hooks/useAuth';
import Layout from './components/Layout';
import Familiarization from './pages/Familiarization';
import LoginPage from './pages/Login';
import InvitePage from './pages/Invite';
import DashboardPage from './pages/Dashboard';
import DashboardPageNew from './pages/DashboardNew';
import ClientsPage from './pages/Clients';
import ClientsPageNew from './pages/ClientsNew';
import TransactionsPage from './pages/Transactions';
import OrdersPage from './pages/Orders';
import OrdersPageNew from './pages/OrdersNew';
import SegmentsPage from './pages/Segments';
import SegmentsPageNew from './pages/SegmentsNew';
import CommunicationsPage from './pages/Communications';
import AutomationsPage from './pages/Automations';
import LoyaltyPage from './pages/Loyalty';
import IntegrationsPage from './pages/Integrations';
import MobileAppsPage from './pages/MobileApps';
import PromocodesPage from './pages/Promocodes';
import PromocodesPageNew from './pages/PromocodesNew';
import PlacesPage from './pages/Places';
import ChainsPage from './pages/Chains';
import TeamPage from './pages/Team';
import AuditPage from './pages/Audit';
import BillingPage from './pages/Billing';
import PromotionsPage from './pages/Promotions';
import {Referrals,GiftCards} from './pages/Growth';
import WalletPage from './pages/Wallet';
import ReturnsPage from './pages/Returns';
import WalletCard from './pages/WalletCard';
import PlatformAdmin from './pages/PlatformAdmin';
import KnowledgePage from './pages/Knowledge';
import ReportsPage from './pages/Reports';
import PixelPage from './pages/Pixel';
import CatalogPage from './pages/Catalog';
import CRMPage from './pages/CRM';
import MaxConnectorPage from './pages/MaxConnector';
import BotsPage from './pages/Bots';
import EntryPointsPage from './pages/EntryPoints';
import EntryPublicPage from './pages/EntryPublic';
import MarketingConsent from './pages/MarketingConsent';
import MaxTestMessagePage from './pages/MaxTestMessage';
import MaxAudiencePage from './pages/MaxAudience';

function AdminRoutes() {
  return (
      <ThemeProvider><AuthProvider>
        <Toaster position="top-right" toastOptions={{ style: { background: 'var(--bg-card)', color: 'var(--text-primary)', border: '1px solid var(--border)', fontSize: '13px' } }} />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/platform/*" element={<PlatformAdmin/>}/>
          <Route element={<Layout />}>
            <Route path="/familiarization" element={<Familiarization/>}/>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/new" element={<DashboardPageNew />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/clients-new" element={<ClientsPageNew />} />
            <Route path="/transactions" element={<TransactionsPage />} />
            <Route path="/delivery-results" element={<DeliveryResults/>}/>
            <Route path="/marketing" element={<Marketing/>}/>
            <Route path="/returns" element={<ReturnsPage/>}/>
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders-new" element={<OrdersPageNew />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/loyalty" element={<LoyaltyPage />} />
            <Route path="/wallet" element={<WalletPage/>}/>
            <Route path="/referrals" element={<Referrals/>}/>
            <Route path="/gift-cards" element={<GiftCards/>}/>
            <Route path="/promotions" element={<PromotionsPage/>}/>
            <Route path="/promocodes" element={<PromocodesPage />} />
            <Route path="/promocodes-new" element={<PromocodesPageNew />} />
            <Route path="/segments" element={<SegmentsPage />} />
            <Route path="/segments-new" element={<SegmentsPageNew />} />
            <Route path="/communications" element={<CommunicationsPage />} />
            <Route path="/automations" element={<AutomationsPage />} />
            <Route path="/mobile-apps" element={<MobileAppsPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/crm" element={<CRMPage />} />
            <Route path="/bots" element={<BotsPage />} />
            <Route path="/entry-points" element={<EntryPointsPage />} />
            <Route path="/max/test-message" element={<MaxTestMessagePage />} />
            <Route path="/max/audience" element={<MaxAudiencePage />} />
            <Route path="/max" element={<MaxConnectorPage />} />
            <Route path="/web-pixel" element={<PixelPage />} />
            <Route path="/places" element={<PlacesPage />} />
            <Route path="/chains" element={<ChainsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/knowledge" element={<KnowledgePage />} />
            <Route path="/reports" element={<ReportsPage />} />
          </Route>
        </Routes>
      </AuthProvider></ThemeProvider>
  );
}
export default function App() {
  return <BrowserRouter><Routes>
    <Route path="/join/:slug" element={<EntryPublicPage />} />
    <Route path="/legal/expressbuket/marketing-consent/v1" element={<MarketingConsent />} />
    <Route path="/wallet-card" element={<WalletCard/>}/>
    <Route path="/*" element={<AdminRoutes />} />
  </Routes></BrowserRouter>;
}
